// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"SupplierDetails_titleContainer__3SkIg","mainColumn":"SupplierDetails_mainColumn__3MFy-","sideColumn":"SupplierDetails_sideColumn__rk_3B"};